import { Tile as TileType } from '../types/game'

interface GuessGridProps {
  guesses: TileType[][]
}

export const GuessGrid = ({ guesses }: GuessGridProps) => {
  // Determine grid dimensions from the guesses array
  const rowCount = guesses.length

  // Use the actual column count from the guesses array with no default
  const colCount = guesses[0]?.length || 0

  if (!guesses?.length || colCount === 0) return null

  return (
    <div className="grid-container">
      <div
        role="grid"
        data-testid="guess-grid"
        className="guess-grid"
        style={{
          gridTemplateRows: `repeat(${rowCount}, var(--tile-size))`,
          gridTemplateColumns: `repeat(${colCount}, var(--tile-size))`,
          gap: 'var(--tile-gap)',
        }}
        aria-label="Guess grid"
      >
        {guesses.map((row, rowIndex) =>
          row.map((tile, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              role="cell"
              className={`grid-cell ${tile.state}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: 'var(--tile-font-size)',
                textTransform: 'uppercase',
                border: '2px solid rgba(255, 255, 255, 0.15)',
                borderRadius: '4px',
                background:
                  tile.state === 'active'
                    ? 'rgba(255, 255, 255, 0.1)'
                    : tile.state === 'correct'
                      ? 'var(--success)'
                      : tile.state === 'wrong-location'
                        ? 'var(--warning)'
                        : tile.state === 'wrong'
                          ? 'rgba(40, 40, 40, 0.9)'
                          : 'rgba(0, 0, 0, 0.3)',
                transition: 'all 0.3s ease',
              }}
            >
              {tile.letter}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
